import { faArrowRotateRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import { useContext } from 'react';

import { OverviewContext } from '../../../providers/overview-provider';

import './styles.scss';

export const RestoreLayoutButton = () => {
  const { resetLayout } = useContext(OverviewContext);

  const handleResetLayout = () => {
    resetLayout();
  };

  return (
    <Button onClick={handleResetLayout} className="btn-restore">
      <FontAwesomeIcon icon={faArrowRotateRight} />
      <span>Restore layout</span>
    </Button>
  );
};
